import React, { useEffect, useState } from 'react';
import { baseUrlService } from '../rest/BaseUrlService';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { BodyText, PageLoading, SpruceHelpInlineLink } from '../components';
import { datadogRum } from '@datadog/browser-rum';
import { useGetEnvironmentVariablesQuery } from 'API/BaseApi';
import type { FCWithChildren } from '../../types/FCWithChildren';

// This initializes baseUrlService and NotificationsService.
// It prevents the application from loading if there is an error fetching environment variables
export const EnvironmentVariablesWrapper: FCWithChildren = ({ children }) => {
  const { data: environmentVariables, error } = useGetEnvironmentVariablesQuery();
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  useEffect(() => {
    if (!environmentVariables) {
      return;
    }
    try {
      const { apiLocation } = environmentVariables;
      baseUrlService.init(apiLocation);
      setIsInitialized(true);
      // This way we can turn off datadog in an environment by setting the sample rate to 0.
      if ((environmentVariables.dataDog?.sessionSampleRate ?? 0) > 0) {
        datadogRum.init({
          ...environmentVariables.dataDog,
          allowedTracingUrls: [baseUrlService.ApiLocation],
        });
      }
    } catch (e: unknown) {
      console.error('Error fetching environment variables', e);
    }
  }, [environmentVariables, setIsInitialized]);
  if (error) {
    return (
      <ErrorMessageTW rtkError={error}>
        <BodyText>
          <br />
          There was an error loading Environment Variables!
          <br />
          Please <SpruceHelpInlineLink /> to submit a request for help
        </BodyText>
      </ErrorMessageTW>
    );
  }
  return <PageLoading isLoading={!isInitialized}>{children}</PageLoading>;
};
